import React from "react";
import "./Loader.css";
import { FaSpinner } from "react-icons/fa";

const Loader = () => {
  return <FaSpinner icon="spinner" className="spinner" />;
};

export default Loader;
